export const DATA_TYPES = {
  email: 'email',
  phone: 'phone',
};
